export const decimals = { value: { min: 0, max: 2 }, fee: { min: 2, max: 4 } };

export const feeScheduleTypeOptions = [
  {
    labelKey: 'tieredFeeByIncrementalValue',
    value: 0,
  },
  {
    labelKey: 'tieredFeeByBreakpoint',
    value: 1,
  },
  {
    labelKey: 'totalFee',
    value: 2,
  },
  {
    labelKey: 'mixed',
    value: 3,
  },
];

export const FEE_SCHEDULE_TYPES = {
  TIERED_FEE_BY_INCREMENTAL_VALUE: 0,
  TIERED_FEE_BY_BREAKPOINT: 1,
  TOTAL_FEE: 2,
  MIXED: 3,
  FLAT_MAX_FEE: 4,
  HISTORIC_MAX_FEE: 5,
};

export const inputFeeTypeOptions = [
  {
    labelKey: 'byTotal',
    value: 0,
  },
  {
    labelKey: 'byBreakdown',
    value: 1,
  },
];

export const maxDiscountOptions = [
  {
    labelKey: 'noDiscountAllowed',
    value: 0,
  },
  {
    labelKey: 'discountAllowed',
    value: 1,
  },
];

export const includeSMAOptions = [
  {
    labelKey: 'yes',
    value: true,
  },
  {
    labelKey: 'no',
    value: false,
  },
];

export const EditingAction = {
  NONE: 0,
  CREATE: 1,
  UPDATE: 2,
};
